import { axiosInstance, authHeader, handleResponse, handleError } from '../helpers';
import { api } from '../constants'

export const fontService = {
    fetchAllFonts,
    uploadFont,
    updateFont,
    deleteFont
};

function fetchAllFonts() {
    const requestOptions = {
        method: 'GET',
        headers: authHeader()
    };

    return axiosInstance.get(api.fonts.fetchAllFonts, requestOptions)
        .then(handleResponse)
        .then(data => {
            return data;
        })
        .catch(error => handleError(error.response));
}

function uploadFont(formData) {

    const requestOptions = {
        method: 'POST',
        headers: {
            ...authHeader(),
            'Content-Type': 'multipart/form-data'
        }
    };

    return axiosInstance.post(api.fonts.uploadFonts, formData, requestOptions)
        .then(handleResponse)
        .then(data => {
            return data;
        })
        .catch(error => handleError(error.response));
}

function updateFont(data) {

    const requestOptions = {
        method: 'PUT',
        headers: authHeader()
    };

    return axiosInstance.put(api.fonts.updateFont, data, requestOptions)
        .then(handleResponse)
        .then(data => {
            return data;
        })
        .catch(error => handleError(error.response));
}

function deleteFont(fontId) {
    const requestOptions = {
        method: 'DELETE',
        headers: authHeader()
    };

    return axiosInstance.delete(`${api.fonts.deleteFont}/${fontId}`, requestOptions)
        .then(handleResponse)
        .then(data => {
            return data;
        })
        .catch(error => handleError(error.response));
}